import React from 'react'
import { Link } from 'react-router-dom'

function DestinationCardTwo(props) {
    const { destination, onClick } = props;

    const headline = (input) => {
        if (!input) return '';

        return input
            .trim()
            .replace(/[-_]+/g, ' ') // replace underscores and hyphens with spaces
            .replace(/\s+/g, ' ')   // collapse multiple spaces
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    // Handle image URL - if it's a full URL, use it as is, otherwise prepend assets path
    const getImageUrl = (image) => {
        if (!image) return '';
        // Remove escaped slashes from JSON response
        const cleanImage = image.replace(/\\/g, '');
        if (cleanImage.startsWith('http://') || cleanImage.startsWith('https://')) {
            return cleanImage;
        }
        return `/assets/img/tour/${cleanImage}`;
    };

    const handleClick = (e) => {
        if (onClick) {
            e.preventDefault();
            onClick(destination);
        }
    };

    return (
        <div className="tour-box style-flex th-ani" style={onClick ? { cursor: 'pointer' } : {}}>
            <div className="tour-box_img global-img">
                <img src={getImageUrl(destination?.image || destination?.thumbnail_image)} alt={destination?.title} />
            </div>
            <div className="tour-content">
                <h3 className="box-title">
                    <Link to={`/destinations/${destination?.slug}`} onClick={handleClick}>{destination.title}</Link>
                </h3>
                <div className="tour-rating">
                    <div
                        className="star-rating"
                        role="img"
                        aria-label="Rated 5.00 out of 5"
                    >
                        <span style={{ width: "100%" }}>
                            Rated
                            <strong className="rating">5.00</strong> out of 5
                            based on <span className="rating">4.8</span>(4.8
                            Rating)
                        </span>
                    </div>
                    <Link
                        to={`/destinations/${destination?.slug}`}
                        className="woocommerce-review-link"
                        onClick={handleClick}
                    >
                        (<span className="count">{destination?.rating ? headline(destination?.rating) : ''}</span>)
                    </Link>
                </div>
                <h4 className="tour-box_price">
                    <span className="currency">{destination?.price ? destination?.price : ''}</span>{destination?.price ? '/Person' : ''}
                </h4>
                <div className="tour-action">
                    {destination?.duration && (
                        <span>
                            <i className="fa-light fa-clock" />{destination?.duration ? destination?.duration : ''} Days
                        </span>
                    )}
                    <Link to={`/destinations/${destination?.slug}`} className="th-btn style4 th-icon" onClick={handleClick}>
                        Book Now
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default DestinationCardTwo

